export default __webpack_public_path__ + "static/media/english-to-hindi-mobile-2.c9e933bb.png";